module.exports = __webpack_public_path__ + "static/img/lr.0cfda4d7.svg";